<template>
  <div class="search" ref="searchPage">
    <div class="search__container">
      <template v-if="hitTeacher && hitTeacher.length === 1">
        <teacher :data="hitTeacher[0]"></teacher>
      </template>
      <template v-if="hitTeacher && hitTeacher.length > 1">
        <teacher-swiper :data="hitTeacher"></teacher-swiper>
      </template>
      <sift-breadcrumb @handleShow="showMore"></sift-breadcrumb>
      <sift-conditions :isShowMore="controlShow"></sift-conditions>
      <div class="list-tab clear" v-if="courseSort && courseSort.length > 0">
        <div
          class="list-tab__title"
          v-for="(item, index) in courseSort"
          :key="index"
          :class="{ 'tab-current': Number(item.id) === Number(currentTab) }"
          @click="sortCourse(item.id, $event)"
        >
          {{ item.name }}
        </div>
        <div class="list-tab__right-bar clear">
          共 <span>{{ courseCount }}</span> 个课程
        </div>
      </div>
      <div class="course-list" v-if="courseList && courseList.length > 0">
        <course-list
          :data="courseList"
          :CardType="'courseCard'"
          :clickId="'1.4.10'"
        ></course-list>
      </div>
      <div v-else>
        <query-keys v-if="showKeys" :data="noCourserecWord"></query-keys>
        <template v-if="noCourserecCourse && noCourserecCourse.length > 0">
          <div class="search__recommend">为您推荐</div>
          <div class="course-list">
            <course-list
              :data="noCourserecCourse"
              :CardType="'noResultsCourseCard'"
              :clickId="'1.4.29'"
            ></course-list>
          </div>
        </template>
      </div>
    </div>
    <div v-if="showNoCase" class="no-course">
      <img
        class="no-course__img"
        src="//res11.xesimg.com/x5mall/img/none_record.png"
        alt=""
      />
      <p class="no-course__text">
        抱歉，没有找到与<span class="color-r">“{{ keyword }}”</span
        >相关的课程，请重新输入关键词
      </p>
    </div>
  </div>
</template>

<script>
import titleMixin from '@/util/title'
import components from './components'
import { mapState, mapActions } from 'vuex'
import types from './store/types'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/fromEvent'
import 'rxjs/add/operator/debounceTime'

export default {
  name: 'search-page',
  componentName: 'SearchPage',
  mixins: [titleMixin],
  components: {
    ...components
  },
  title(route) {
    try {
      const keyword = route.query.keyword || '直播课'
      return `${keyword}-学而思网校`
    } catch (error) {
      console.log('===course-center-title===', error)
      return '学而思网校-受益一生的能力'
    }
  },
  data() {
    return {
      scrollLoading: false,
      scrollObservable: null,
      isLoadMore: true,
      // currentTab: 1,
      page: 1,
      controlShow: false
    }
  },
  created() {
    this.$on('LoginStatusCompleted', async isLogin => {
      if (isLogin) {
        this.getCourseList({ sort: 1, page: 1, route: this.$route })
        this.getSearchSift({ route: this.$route })
      }
    })
  },
  async mounted() {
    this.scrollObservable = Observable.fromEvent(window, 'scroll')
      .debounceTime(1000 / 60)
      .subscribe(() => {
        this.scrollLoad()
      })
    let key = this.courseList && this.courseList.length > 0 ? 'xeslog-searchPage-exposure':'xeslog-searchPage-noResults-exposure';
    this.xesLog(
      'exposure',
      { key: key, ...this.xesLogParams },
      { target: this.$refs.searchPage }
    )
  },
  asyncData({ store, route }) {
    const { dispatch } = store
    return Promise.all([
      dispatch(types.GET_SEARCH_COURSE_LIST, { route }), // 获取课程列表
      dispatch(types.GET_SEARCH_SIFT, { route }) // 获取删选信息
    ])
  },
  computed: {
    ...mapState({
      userIsLogin: state => state.userIsLogin,
      courseList: state => state.SearchPage.courseList,
      pageCount: state => state.SearchPage.pageCount,
      courseSort: state => state.SearchPage.courseSort,
      courseCount: state => state.SearchPage.courseCount,
      noCourserecCourse: state => state.SearchPage.noCourserecCourse,
      hitTeacher: state => state.SearchPage.hitTeacher,
      noCourserecWord: state => state.SearchPage.noCourserecWord,
      chooseSift: state => state.SearchPage.chooseSift,
      searchSift: state => state.SearchPage.searchSift,
      dataExpTag: state => state.SearchPage.dataExpTag
      // ,
      // page: state => state.SearchPage.page
    }),
    hasMore() {
      return this.page < this.pageCount
    },
    currentTab() {
      const { sort = 1 } = this.$route.query
      return sort
    },
    showKeys() {
      return (
        (this.noCourserecWord && this.noCourserecWord.length > 0) ||
        (this.noCourserecCourse && this.noCourserecCourse.length > 0)
      )
    },
    showNoCase() {
      return (
        (!this.courseList || this.courseList.length < 1) &&
        (!this.noCourserecWord || this.noCourserecWord.length < 1) &&
        (!this.noCourserecCourse || this.noCourserecCourse.length < 1)
      )
    },
    keyword() {
      const { keyword = '' } = this.$route.query
      return keyword
    },
    courseLogId() {
      if (this.courseList && this.courseList.length > 0) {
        const courselistId = this.courseList.map(item => {
          return {
            id: item.id
          }
        })
        return courselistId
      }
      return null
    },
    teacherLogId() {
      if (this.hitTeacher && this.hitTeacher.length > 0) {
        const teacherlistId = this.hitTeacher.map(item => {
          return {
            id: item.id
          }
        })
        return teacherlistId
      }
      return null
    },
    noCourseId() {
      if (this.noCourserecCourse && this.noCourserecCourse.length > 0) {
        const noCourseId = this.noCourserecCourse.map(item => {
          return {
            id: item.id
          }
        })
        return noCourseId
      }
      return null
    },
    searchSiftLog() {
      let obj = Object.create(null)
      if (
        this.searchSift &&
        this.searchSift.constructor === Object &&
        Object.keys(this.searchSift).length > 0
      ) {
        let keysArr = Object.keys(this.searchSift)
        for (let item of keysArr) {
          let arr = this.searchSift[item].map(_item => {
            return _item.id
          })
          obj[item] = arr
        }
      }
      return obj
    },
    chooseSiftLog() {
      let obj = Object.create(null)
      for (let item in this.chooseSift) {
        obj[item] = this.chooseSift[item].id
      }
      return obj
    },
    xesLogParams() {
      let params = Object.create(null)
      if (this.courseList && this.courseList.length > 0) {
        params = {
          choosedoption: this.chooseSiftLog,
          chooseoption: this.searchSiftLog,
          courselist: this.courseLogId,
          teacherlist: this.teacherLogId
        }
      } else {
        params = {
          key: 'xeslog-searchPage-noResults-exposure',
          recquerylist: this.noCourserecWord,
          reccourselist: this.noCourseId
        }
      }
      return params
    }
  },
  beforeMount() {
    if (this.userIsLogin) {
      this.getCourseList({ sort: 1, page: 1, route: this.$route })
      this.getSearchSift({ route: this.$route })
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.page = 1
    const {
      query: { isLogin, isLogout, isRegister }
    } = from
    if (isLogin || isLogout || isRegister) {
      next()
      return
    }
    next()
  },
  watch: {
    $route() {
      let key = this.courseList && this.courseList.length > 0 ? 'xeslog-searchPage-exposure':'xeslog-searchPage-noResults-exposure';
      this.xesLog(
        'exposure',
        { key: key, ...this.xesLogParams },
        { target: this.$refs.searchPage }
      )
    }
  },
  methods: {
    ...mapActions({
      getCourseList: types.GET_SEARCH_COURSE_LIST,
      getSearchSift: types.GET_SEARCH_SIFT
    }),
    showMore() {
      this.controlShow = !this.controlShow
    },
    async scrollLoad() {
      const innerHeight = Math.ceil(window.innerHeight)
      const scrollY = Math.ceil(window.scrollY)
      const scrollHeight = document.body.scrollHeight
      if (this.scrollLoading) return
      if (scrollHeight < scrollY + innerHeight + 50) {
        // 到达底部 加载更多
        this.scrollLoading = true
        this.getCourses()
      }
    },
    async getCourses() {
      if (!this.hasMore) {
        this.scrollLoading = false
        return
      }
      try {
        const page = this.page + 1
        await this.getCourseList({
          page: page,
          sort: this.currentTab,
          route: this.$route
        })
        this.scrollLoading = false
        this.page = page
        this.xesLog(
          'click',
          { key: 'xeslog-pulldown-getmorecourse', clickid: '1.4.48', pageid: this.page },
          { target: this.$refs.searchPage }
        )
      } catch (e) {
        console.log('===getCourses error===', e)
        this.scrollLoading = false
        if (this.page > 2) {
          this.page = this.page - 1
        }
      }
    },
    sortCourse(id, event) {
      // this.currentTab = id
      // this.getCourseList({sort: id, page: 1, route: this.$route})
      this.$router.push({
        name: this.$route.name,
        query: {
          ...this.$route.query,
          sort: id
        }
      })
    },
    xesLog(eventName, params, event) {
      const XESLog = new this.$XESLog({
        sorttype: this.$route.query.sort ? this.$route.query.sort : 1,
        setgradeid: this.$store.state.cookies.userGrade,
        curgradeid: this.$store.state.cookies.currentGrade,
        query: this.$route.query.keyword,
        ...params,
        exp_tag: this.dataExpTag
      })
      XESLog.push({ eventname: eventName, target: event.target }, this.$route)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
@include b(search) {
  min-width: 1200px;
  margin: 0 auto;
  @include e(container) {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 30px;
  }
  @include e(recommend) {
    font-size: 16px;
    color: #333333;
    margin-top: 32px;
    margin-bottom: 10px;
    font-weight: bold;
  }
}
@include b(list-tab) {
  height: 40px;
  line-height: 40px;
  border-bottom: 2px solid #DCAF80;
  font-size: 14px;
  margin-bottom: 10px;
  @include e(title) {
    background-color: #DCAF80;
    color: #fff;
    float: left;
    padding: 0 14px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }
  .tab-current {
    background: #333333;
    color: #fff;
  }
  @include e(right-bar) {
    font-size: 12px;
    height: 40px;
    line-height: 40px;
    float: right;
    & > div {
      float: left;
    }
    & > span {
      color: #f23232;
    }
  }
}
.course-list {
  margin-left: -4.5px;
  margin-right: -4.5px;
}
@include b(no-course) {
  text-align: center;
  margin-top: 25px;
  & > p {
    margin-top: 20px;
    line-height: 35px;
    font-size: 16px;
  }
  @include e(img) {
    width: 200px;
    height: 200px;
  }
}
.color-r {
  color: #f00;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// ./src/views/SearchPage/index.vue